import React from 'react';
import {Typography, makeStyles, createStyles} from '@material-ui/core';
import {connect, useSelector} from 'react-redux';
// components
import CreditDebitCard from '@components/system/MyIcons/CreditDebitCard';
import MailCheck from '@components/system/MyIcons/MailCheck';
import RightArrow from '@components/system/MyIcons/RightSideArrow';
// styles
import './PaymentsMethodsStyles.scss';
import {PAYMENTS_BACKGROUND_COLOR, BORDER_COLOR} from 'src/style/variable';

const useStyles = makeStyles(() =>
  createStyles({
    paymentIcon: {
      height: '30px',
      paddingTop: '0.1rem',
      paddingRight: 0
    },
    rightArrow: {
      paddingRight: '2rem'
    },
    border: {
      border: `1px solid ${PAYMENTS_BACKGROUND_COLOR}`,
      background: `${PAYMENTS_BACKGROUND_COLOR}45`
    },
    paymentWrapperColor: {
      border: `1px solid ${BORDER_COLOR}`
    }
  })
);
const PaymentsMethod = (props: any): React.ReactElement => {
  const {name, id, paymentId} = props;
  const classes = useStyles();
  const paymentMethodId = useSelector(
    (state: any) => state.payments.paymentMethodId
  );
  const icon = (key: any) => {
    if (key == 1) {
      return <CreditDebitCard className={classes.paymentIcon} />;
    } else if (key == 2) {
      return <MailCheck className={classes.paymentIcon} />;
    }
  };

  return (
    <Typography className={['payment-method-view'].join(' ')} component={'div'}>
      <div
        className={[
          'payment-method-wrapper',
          paymentMethodId === paymentId
            ? classes.border
            : classes.paymentWrapperColor
        ].join(' ')}>
        <div className="payment-icon">{icon(id)}</div>
        <div className="header-payment-name">{name}</div>
        <div className={classes.rightArrow}>
          <RightArrow />
        </div>
      </div>
    </Typography>
  );
};

function mapStateToProps(state: any): any {
  return {
    paymentMethodId: state.payments.paymentMethodId
  };
}
export default connect(mapStateToProps, {})(PaymentsMethod);
